import {isNotUndefined} from '@practicegenius/pg-util/src/TypescriptUtils';
import {isClient} from '@practicegenius/pg-ui/src/utils/environment';
import envJS from '../../../.env.js';

const {
  PG_CORE_URL,
  PG_COMM_URL,
  MY_DOT_URL,
  SANITY_URL,
  FILES_URL,
  ASSETS_URL,
  BASE_URL,
  GOOGLE_MAPS_KEY,
  GOOGLE_RECAPTCHA_SITE_KEY,
  PUSHER_KEY,
  PUSHER_CLUSTER,
  PUSHER_HOST,
  GIPHY_API_KEY,
} = envJS;

const __DEV__ = process.env.NODE_ENV === 'development';
const __TEST__ = process.env.NODE_ENV === 'test';
const __PROD__ = process.env.NODE_ENV === 'production';

export {
  PG_CORE_URL,
  PG_COMM_URL,
  MY_DOT_URL,
  SANITY_URL,
  FILES_URL,
  ASSETS_URL,
  BASE_URL,
  GOOGLE_MAPS_KEY,
  GOOGLE_RECAPTCHA_SITE_KEY,
  PUSHER_KEY,
  PUSHER_CLUSTER,
  PUSHER_HOST,
  GIPHY_API_KEY,
  __DEV__,
  __TEST__,
  __PROD__,
};

/**
 * Detect the storybook context
 */
export const isStorybook: boolean =
  isClient &&
  isNotUndefined(
    // @ts-ignore this is set by storybook
    window.STORYBOOK_ENV,
  );
